import { API, API_IA } from './index'
import { AnyAction, Dispatch } from 'redux'
import { logoutUser } from '@mv-submodules/inplant-coreadapter-fe/auth'
import { ChecklistPhotoModel, ChecklistPhoto } from '../../types/checklistPhotos'
import { Results } from '@mv-submodules/inplant-checklist-fe-iblu/ui/components/widgets/Image/Image'
import { stringify } from '@mv-submodules/mvlabs-components-fe/functions/apiFormatter'

const checklistPhotoModelsFetching = (): AnyAction => ({
  type: 'CHECKLIST_PHOTO_MODELS_FETCHING',
})

const checklistPhotoModelsSuccess = (data: ChecklistPhotoModel[]): AnyAction => ({
  type: 'CHECKLIST_PHOTO_MODELS_SUCCESS',
  data,
})

const checklistPhotoModelsFailure = (error: Error): AnyAction => ({
  type: 'CHECKLIST_PHOTO_MODELS_FAILURE',
  error,
})

// TODO
const checklistPhotoModels = () => async (dispatch: Dispatch<AnyAction>): Promise<ChecklistPhotoModel[]> => {
  dispatch(checklistPhotoModelsFetching())
  try {
    const data: ChecklistPhotoModel[] = await API().request(`/photo-models`)
    dispatch(checklistPhotoModelsSuccess(data))
    return data
  } catch (error:any) {
    if (error.name === 'FetchError' && error.statusCode === 401) {
      dispatch(logoutUser())
    } else {
      dispatch(checklistPhotoModelsFailure(error))
    }
    throw error
  }
}

const checklistPrediction = (imagePath: string) => async (dispatch: Dispatch<AnyAction>): Promise<Results> => {
  try {
    return API()
      .request(imagePath)
      .then((blob: Blob) => {
        const formData = new FormData()
        formData.append('file', blob, imagePath)

        const requestOptions: RequestInit = {
          method: 'POST',
          headers: { Accept: 'multipart/form-data' },
          body: formData,
          redirect: 'follow',
        }

        return API_IA()
          .request('/checklist-ia/predict', requestOptions,false,true)
          .then((responseText: string) => responseText as Results)
      })
  } catch (error:any) {
    if (error.name === 'FetchError' && error.statusCode === 401) {
      dispatch(logoutUser())
    }
    throw error
  }
}

const checklistPhotosFetching = (): AnyAction => ({
  type: 'CHECKLIST_PHOTO_MODELS_FETCHING',
})

const checklistPhotosSuccess = (data: ChecklistPhotoModel[]): AnyAction => ({
  type: 'CHECKLIST_PHOTO_MODELS_SUCCESS',
  data,
})

const checklistPhotosFailure = (error: Error): AnyAction => ({
  type: 'CHECKLIST_PHOTO_MODELS_FAILURE',
  error,
})

interface ChecklistPhotoFilters {
  userDisplayName?: string
}

const checklistPhotos = (modelId: string, date: string, filters: ChecklistPhotoFilters = {}) => async (
  dispatch: Dispatch<AnyAction>
): Promise<ChecklistPhoto[]> => {
  dispatch(checklistPhotosFetching())
  try {
    const queryString = stringify(filters)
    const path = `/photo-details/${modelId}/${date}`
    const requestUrl = queryString ? `${path}?${queryString}` : path
    const data: ChecklistPhoto[] = await API().request(requestUrl)
    dispatch(checklistPhotosSuccess(data))
    return data
  } catch (error: any) {
    if (error.name === 'FetchError' && error.statusCode === 401) {
      dispatch(logoutUser())
    } else {
      dispatch(checklistPhotosFailure(error))
    }
    throw error
  }
}

export {
  checklistPhotoModels,
  checklistPrediction,
  checklistPhotos
}

export type {
  ChecklistPhotoFilters
}
